import InfoSelector from './src/main';

/* istanbul ignore next */
InfoSelector.install = function(Vue) {
  Vue.component(InfoSelector.name, InfoSelector);
};

export default InfoSelector;
